export default "__VITE_ASSET__ZQjeq9DF__"